import { service } from '@ember/service';

import Model, { attr, belongsTo } from '@warp-drive/legacy/model';
import moment from 'moment';

import { buildValidations } from 'umg-ember-backend/utils/validations';

const Validations = buildValidations({});

export default class A11yScanModel extends Model.extend(Validations) {
  // Services
  @service intl;

  // Attributes
  @attr('number') status;
  @attr lastScanStart;
  @attr lastScanEnd;
  @attr('number') violationsTotal;
  @attr('number') violationsA;
  @attr('number') violationsAA;
  @attr('number') violationsAAA;
  @attr('number') scoreTotal;
  @attr('number') errorCount;
  @attr timeEstimation;

  // Relations
  @belongsTo('a11y-scanner', { async: true, inverse: null }) scanner;

  // Meta fields
  @attr cmsCreated;
  @attr cmsModified;
  @attr() cmsHistory;
  @belongsTo('user', { async: true, inverse: null }) cmsCreatorId;
  @belongsTo('user', { async: true, inverse: null }) cmsModifierId;

  // Getter and setter
  get displayHeadline() {
    return this.id;
  }

  get displayLabel() {
    return this.id;
  }

  get statusLabel() {
    if (this.status === 1) {
      return this.intl.t('tables.a11y-scan.options.statusLabel.done');
    }

    if ([3, 4].includes(this.status)) {
      return this.intl.t('tables.a11y-scan.options.statusLabel.archived');
    }

    if (!this.timeEstimation.estimatedTime) {
      return this.intl.t('tables.a11y-scan.options.statusLabel.crawling');
    }

    return moment.duration(this.timeEstimation.estimatedTime).humanize();
  }
}
